export default "__VITE_ASSET__4c265835__"